{
  "pages": {
    "tickets": {
      "title": "Tickets",
      "createTitle": "Créer un ticket",
      "loading": "Chargement du ticket…"
    },
    "reports": {
      "title": "Rapports service client"
    },
    "cannedResponses": {
      "title": "Réponses prédéfinies"
    },
    "inbox": {
      "title": "Boîte de réception"
    },
    "setup": {
      "title": "Configuration service client"
    },
    "workflowDesigner": {
      "title": "Concepteur de workflow"
    },
    "boards": {
      "title": "Tableaux service client"
    },
    "knowledgeBase": {
      "title": "Base de connaissances"
    },
    "automation": {
      "title": "Automatisation service client"
    },
    "liveChat": {
      "title": "Chat en direct"
    },
    "support360": {
      "description": "Support client 360 — tickets, CRM, finance et historique omnicanal",
      "loading": "Chargement du profil support…"
    },
    "dashboard": {
      "title": "Tableau de bord service client",
      "description": "Volume support, santé SLA et état des files selon votre niveau d'accès",
      "queueDetails": "Détails des files",
      "unassigned": "Non assignés",
      "totalTickets": "Total tickets"
    },
    "ruleBasedTriggersOnTicketAnd": "Rule-based triggers on ticket et SLA events",
    "kanbanViewOfTicketsByWorkflow": "Kanban afficher of tickets by flux de travail status",
    "reusableReplySnippetsForAgents": "Reusable reply snippets pour agents",
    "noCannedResponsesYet": "No canned responses yet",
    "emailConversationsLinkedToTicketsReply": "Email conversations linked à tickets — reply via SMTP",
    "categoriesAndArticlesForAgentsAnd": "Categories et articles pour agents et client portal",
    "realtimeCustomerConversations": "Realtime client conversations",
    "ticketVolumeSlaBreachesAndAgent": "Ticket volume, SLA breaches, et agent performance",
    "statuses": "Statuses",
    "priorities": "Priorities",
    "teams": "Teams",
    "statusesPrioritiesTeamsInboundMailboxImap": "Statuses, priorities, teams, inbound mailbox, IMAP polling, client portal, business hours",
    "defineAllowedStatusTransitionsAndRole": "Define allowed status transitions et role ACLs",
    "omnichannelSupportTicketsWithConfigurableWorkflows": "Omnichannel support tickets avec configurable flux de travails"
  },
  "toast": {
    "ticketCreated": "Ticket créé",
    "workflowCreated": "Workflow créé",
    "transitionAdded": "Transition ajoutée",
    "cannedResponseUpdated": "Réponse prédéfinie mise à jour",
    "cannedResponseCreated": "Réponse prédéfinie créée",
    "categoryCreated": "Catégorie créée",
    "articleCreated": "Article créé",
    "imapSettingsSaved": "Paramètres IMAP enregistrés",
    "inboundProcessed": "{{count}} messages entrants traités",
    "replySent": "Réponse envoyée",
    "timelineAdded": "Ajouté à la chronologie",
    "statusUpdated": "Statut mis à jour",
    "attachmentAdded": "Pièce jointe ajoutée",
    "csatRecorded": "CSAT enregistré",
    "reportExported": "Rapport exporté en {{format}}"
  },
  "errors": {
    "loadReportsFailed": "Échec du chargement des rapports service client",
    "exportFailed": "Échec de l'export",
    "createFailed": "Échec de la création",
    "createWorkflowFailed": "Échec de la création du workflow",
    "addTransitionFailed": "Échec de l'ajout de la transition",
    "loadCannedResponsesFailed": "Échec du chargement des réponses prédéfinies",
    "saveFailed": "Échec de l'enregistrement",
    "deleteFailed": "Échec de la suppression",
    "createCategoryFailed": "Échec de la création de la catégorie",
    "createArticleFailed": "Échec de la création de l'article",
    "loadSupport360Failed": "Échec du chargement du Support client 360",
    "loadSetupFailed": "Échec du chargement de la configuration",
    "updateCalendarFailed": "Échec de la mise à jour du calendrier métier",
    "addHolidayFailed": "Échec de l'ajout du jour férié",
    "saveImapFailed": "Échec de l'enregistrement des paramètres IMAP",
    "syncFailed": "Échec de la synchronisation",
    "loadLiveChatsFailed": "Échec du chargement des chats en direct",
    "loadThreadFailed": "Échec du chargement du fil",
    "sendReplyFailed": "Échec de l'envoi de la réponse",
    "loadTicketFailed": "Échec du chargement du ticket",
    "addCommentFailed": "Échec de l'ajout du commentaire",
    "transitionFailed": "Échec de la transition",
    "uploadFailed": "Échec du téléversement",
    "recordCsatFailed": "Échec de l'enregistrement du CSAT",
    "loadInboxFailed": "Échec du chargement de la boîte de réception",
    "loadMessagesFailed": "Échec du chargement des messages",
    "loadAutomationFailed": "Échec du chargement des règles d'automatisation",
    "loadBoardFailed": "Échec du chargement du tableau",
    "failedToLoadTickets": "Échec du chargement de tickets"
  },
  "labels": {
    "title": "Title",
    "shortcutCode": "Shortcut code",
    "categoryCode": "Category code",
    "body": "Body",
    "replyToCustomer": "Reply à client",
    "name": "Nom",
    "category": "Category",
    "content": "Content",
    "none": "— None —",
    "agentReply": "Agent reply",
    "totalTickets": "Total tickets",
    "openTickets": "Open tickets",
    "unassigned": "Unassigned",
    "slaBreaches": "SLA breaches",
    "averageCsat": "Average CSAT",
    "imapHost": "IMAP host",
    "port": "Port",
    "username": "Username",
    "password": "Password",
    "calendarName": "Calendar name",
    "timezone": "Timezone",
    "workStart": "Work start",
    "workEnd": "Work end",
    "date": "Date",
    "passwordAppPassword": "Password (app password)",
    "newWorkflowName": "New flux de travail name",
    "fromStatus": "From status",
    "toStatus": "To status",
    "allowedRoleCodeOptional": "Allowed role code (optional)",
    "invoices": "Factures",
    "avgCsat": "Avg CSAT",
    "rating": "Rating",
    "feedbackOptional": "Feedback (optional)",
    "replyNote": "Reply / note",
    "subject": "Subject *"
  },
  "formActions": {
    "saveImap": "Enregistrer IMAP",
    "saveCalendar": "Enregistrer le calendrier",
    "addHoliday": "Ajouter un jour férié",
    "addTransition": "Ajouter une transition",
    "createWorkflow": "Créer un workflow",
    "addToTimeline": "Ajouter à la chronologie"
  },
  "listActions": {
    "newTicket": "Nouveau ticket",
    "workflowDesigner": "Concepteur de flux de travail",
    "cannedResponses": "Réponses prédéfinies",
    "sendReply": "Envoyer la réponse"
  }
}
